export const menu = [
	{ name: "Home", path: "/" },
	{ name: "About Us", path: "/about-us" },
	{
		name: "Services",
		path: "/services",
		hasDropdown: true,
	},
	{ name: "Contact Us", path: "/contact-us" },
];
